import React from 'react';
import { Input, Select, Radio, Checkbox, Row, Col, DatePicker, Icon } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                            loading={this.props.establecimientosLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.establecimientos.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idAlmacen ? { key: this.props.filter.idAlmacen } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por almacén" />}
                            onChange={(option) => this.props.onChange("idAlmacen", option.key)}
                            optionFilterProp="children"
                            loading={this.props.monedasLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.almacenes.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idTipoProducto ? { key: this.props.filter.idTipoProducto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Tipo Producto" />}
                            onChange={(option) => {
                                //this.props.form.setFieldsValue({ idProducto: undefined });
                                this.props.onChange("idTipoProducto", option.key)
                            }}
                            optionFilterProp="children"
                        >
                            {this.props.tipoProductos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            defaultActiveFirstOption={false}

                            value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Producto" />}
                            onChange={(option) => this.props.onChange("idProducto", option.key)}
                            onSearch={this.props.onSearch}

                            optionFilterProp="children"
                        >
                            {this.props.productos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por codigo referencia"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMarca ?
                                    { key: this.props.filter.idMarca } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Marca" />}
                            onChange={(option) => this.props.onChange("idMarca", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.marcas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    
                    <Col className="gutter-row" sm={24} md={24} lg={6}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Ranking</Radio>
                                <Radio value={2}>Resumen</Radio>
                                <Radio value={3}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} align="middle">

                    <Col className="gutter-row" sm={24} md={24} lg={24}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoComprobante}
                                onChange={(e) => this.props.onChange("tipoComprobante", e.target.value)}
                            >
                                <Radio value={1}>Solo comprobantes tributarios</Radio>
                                <Radio value={2}>Solo notas de ventas</Radio>
                                <Radio value={0}>Todos los comprobantes</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}